import { useLayoutEffect, useState } from 'react';

// Portrait phones and short, touch-oriented phone landscapes share one mode.
export const MOBILE_OFFICE_QUERY = '(max-width: 767px), (max-width: 1023px) and (max-height: 500px) and (pointer: coarse)';
const editing = element => element?.matches('textarea, [contenteditable="true"], input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="range"]):not([type="color"])');

export default function useMobileOfficeNavigation() {
  const [mobile, setMobile] = useState(() => Boolean(window.matchMedia?.(MOBILE_OFFICE_QUERY).matches));
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  useLayoutEffect(() => {
    const query = window.matchMedia?.(MOBILE_OFFICE_QUERY);
    const viewport = window.visualViewport;
    let restingHeight = window.innerHeight, restingWidth = window.innerWidth, frame;
    const measure = () => {
      const activeInput = editing(document.activeElement);
      if (!activeInput || Math.abs(window.innerWidth - restingWidth) > 80) {
        restingHeight = window.innerHeight; restingWidth = window.innerWidth;
      }
      setMobile(Boolean(query?.matches));
      // Pinch zoom is not a keyboard. Keep navigation available when zooming.
      setKeyboardOpen(Boolean(query?.matches && activeInput && (!viewport || viewport.scale <= 1.05)
        && Math.max(restingHeight, window.innerHeight) - (viewport?.height || window.innerHeight) > 120));
    };
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(measure); };
    measure();
    query?.addEventListener?.('change', schedule);
    if (!query?.addEventListener) query?.addListener?.(schedule);
    window.addEventListener('resize', schedule);
    viewport?.addEventListener('resize', schedule);
    document.addEventListener('focusin', schedule); document.addEventListener('focusout', schedule);
    return () => {
      cancelAnimationFrame(frame);
      query?.removeEventListener?.('change', schedule);
      if (!query?.removeEventListener) query?.removeListener?.(schedule);
      window.removeEventListener('resize', schedule);
      viewport?.removeEventListener('resize', schedule);
      document.removeEventListener('focusin', schedule); document.removeEventListener('focusout', schedule);
    };
  }, []);
  return { mobile, keyboardOpen };
}
